import {
    AnimalAddressForm,
    AnimalForm,
    ChipCodeForm,
    ChipFormType,
    ChipInformationForm,
    ChipRegistrationRootForm,
    OwnerForm
} from "@app/models/chip.model";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";

import { code15Validator } from "@app/models/chip-code.type";

export function buildChipForm(fb: FormBuilder, chipFormType: ChipFormType): FormGroup<ChipRegistrationRootForm> {
    const baseFormGroupConfig: ChipRegistrationRootForm = {
        chip: fb.group<ChipCodeForm>({
            code: new FormControl(null, {
                nonNullable: true,
                validators: [code15Validator(), Validators.required],
            }),
        }),
        chipInformation: fb.group<ChipInformationForm>({
            vetId: new FormControl('', { nonNullable: true }),
            selectedVetDocumentId: new FormControl('', { nonNullable: true }),
            date: new FormControl({value: new Date(), disabled: true}, { nonNullable: true }),
            chipReaded: new FormControl(false, {
                nonNullable: true,
                validators: [Validators.requiredTrue],
            }),
        }),
        owner: fb.group<OwnerForm>({
            idType: new FormControl(1, { nonNullable: true }),
            idNumber: new FormControl('', { nonNullable: true, updateOn: 'blur' }),
            nameSurname: new FormControl('', { nonNullable: true }),
            countryId: new FormControl(1, { nonNullable: true }),
            regionId: new FormControl(1, { nonNullable: true }),
            settlementId: new FormControl(null, { nonNullable: true }),
            address: new FormControl('', { nonNullable: true }),
            zipCode: new FormControl('', { nonNullable: true }),
            phone: new FormControl('', { nonNullable: true }),
            email: new FormControl('', { nonNullable: true, validators: [Validators.email] }),
            ...(chipFormType !== 'Registration' ? {
                isAddressSameAsOwner: new FormControl(false, { nonNullable: true }),
            } : {}),
        }),
        animal: fb.group<AnimalForm>({
            type: new FormControl('dog', {
                nonNullable: true,
                validators: [Validators.required],
            }),
            breed: new FormControl(1, { nonNullable: true, validators: [Validators.required] }),
            name: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
            sex: new FormControl(1, { nonNullable: true, validators: [Validators.required] }),
            dateOfBirth: new FormControl('', {
                nonNullable: true,
                validators: [Validators.required],
            }),
            chipLocation: new FormControl(1, {
                nonNullable: true,
                validators: [Validators.required],
            }),
            coatType: new FormControl(1, {
                nonNullable: true,
                validators: [Validators.required],
            }),
            size: new FormControl(1, { nonNullable: true, validators: [Validators.required] }),
            castrated: new FormControl(false, { nonNullable: true }),
            isAddressSameAsOwner: new FormControl(false, { nonNullable: true }),
        }),
        animalAddress: fb.group<AnimalAddressForm>({
            countryId: new FormControl(1, { validators: [Validators.required] }),
            regionId: new FormControl(1, { validators: [Validators.required] }),
            settlementId: new FormControl(null, { validators: [Validators.required] }),
            address: new FormControl('', { validators: [Validators.required] }),
            zipCode: new FormControl('', { validators: [Validators.required] }),
        }),

        ...(chipFormType === 'Registration' ? {
            ownerSignature: new FormControl('', { validators: [Validators.required] }),
            vetSignature: new FormControl('', { validators: [Validators.required] }),
        } : {}),
        ...(chipFormType === 'ChangeOwner' ? {
            ownerSignature: new FormControl(null, { validators: [Validators.required] }),
            vetSignature: new FormControl(null, { validators: [Validators.required] }),
            previousOwnerSignature: new FormControl(null, { validators: [Validators.required] }),
        } : {}),
    };


    return fb.group<ChipRegistrationRootForm>(baseFormGroupConfig);
}
